import { z } from "zod";

import {
  EMAIL_REQUIRED_MESSAGE,
  EMAIL_MAX_LENGTH_MESSAGE,
  EMAIL_FORMAT_MESSAGE,
  PASSWORD_REQUIRED_MESSAGE,
} from "./message";
import { EMAIL_REGEX, MAX_EMAIL_LENGTH, PASSWORD_REGEX } from "./patterns";

export const loginSchema = z.object({
  email: z
    .string({ required_error: EMAIL_REQUIRED_MESSAGE })
    .min(1, EMAIL_REQUIRED_MESSAGE)
    .max(MAX_EMAIL_LENGTH, EMAIL_MAX_LENGTH_MESSAGE)
    .regex(EMAIL_REGEX, EMAIL_FORMAT_MESSAGE),
  
  password: z
    .string({ required_error: PASSWORD_REQUIRED_MESSAGE })
    .min(1, PASSWORD_REQUIRED_MESSAGE)
    .regex(PASSWORD_REGEX, {
      message: "※8～72文字の間で設定してください。<br/>※半角英字、半角数字の2種類を使用してください。<br/>【使用可能な記号 】 !\"#$%&''()-^@[;:",
    }),
});

export type LoginFormData = z.infer<typeof loginSchema>;